import React from "react";
import NumberOneBlue from "../../images/Svg/dashboard/NumberOneBlue.dashboard.svg";
import NumberOne from "../../images/Svg/dashboard/NumberOne.dashboard.svg";
import NumberTwoIcon from "../../images/Svg/dashboard/NumberTwo.dashboard.svg";
import NumberTwoBlue from "../../images/Svg/dashboard/NumberTwoBlue.dashboard.svg";
import NumberThreeIcon from "../../images/Svg/dashboard/NumberThree.dashboard.svg";
import NumberThreeBlue from "../../images/Svg/dashboard/NumberThreeBlue.dashboard.svg";
// import NumberThree from "../../images/Svg/NumberThree.svg";
import { useParams } from "react-router-dom";
import GoBack from "../goBack/GoBack";

export const checkingStep1 = [
  "/twitter/sync_your_content",
  "/wordpress/sync_your_content",
  // "/tiktok/sync_your_content",
  // "/instagram/sync_your_content",
  // "/facebook/sync_your_content",
];
export const checkingStep2 = [
  "/twitter/real_time_sync",
  "/twitter/past_all_contents",
  "/wordpress/real_time_sync",
  // "/wordpress/past_all_contents",
  // "/tiktok/real_time_sync",
  // "/tiktok/sync_past",
  // "/instagram/real_time_sync",
  // "/instagram/sync_past",
  // "/facebook/real_time_sync",
  // "/facebook/sync_past",
];
export const checkArray = (array, pn) => {
  return array.includes(pn);
};

export default function StepComponents() {
  const pn = window.location.pathname;

  // check array if pn is in array then return true else return false

  const resultStep1 = checkArray(checkingStep1, pn);
  const resultStep2 = checkArray(checkingStep2, pn);

  let stepData = [
    {
      id: "1",
      title: "Connect Social Media",
      icon: pn == "/dashboard" ? NumberOneBlue : NumberOne,
      color: pn == "/dashboard" ? "text-[#000000]" : "text-[#585858]",
    },
    {
      id: "2",
      title: "Select Method",
      icon: resultStep1 ? NumberTwoBlue : NumberTwoIcon,
      color: resultStep1 ? "text-[#000000]" : "text-[#585858]",
    },
    {
      id: "3",
      title: "Sync Content",
      icon: resultStep2 ? NumberThreeBlue : NumberThreeIcon,
      color: resultStep2 ? "text-[#000000]" : "text-[#585858]",
    },
  ];
  return (
    <>
      <div className="flex_thing justify-center md:justify-between mb-[40px] mx-auto">
        <div className="hidden md:inline ">
          <GoBack />
        </div>
        <div className="flex_thing">
          {stepData.map((item, index) => {
            return (
              <div
                key={index}
                className="flex items-start sm:items-center mr-[16px] md:mr-[24px]"
              >
                <img src={item.icon} alt="icon" />
                <span
                  className={`${item?.color} text-[14px] margin_top sm:-mt-[0px] ml-[4px]`}
                >
                  {item.title}
                </span>
              </div>
            );
          })}
        </div>
        <div></div>
      </div>
      <div className="md:hidden my-[30px]">
        <GoBack />
      </div>
    </>
  );
}
